import { devicePermissionNames } from "./definition";

export const isPermissionName = (permissionName: string): permissionName is PermissionName => {
  // workaround for https://github.com/microsoft/TypeScript/issues/33923
  return devicePermissionNames.some(p => p === permissionName);
};
